import isEmpty from 'lodash.isempty';
import compact from 'lodash.compact';
import { getUrlParams, getUrlString } from '../../../../utils/shared/urlUtils';
import { STUDENT_SUMMARY_PATHS } from '../../../../constants/shared/ApiConstants';

const { SS_BENCHMARK_HISTORY, SS_PROGRESS, SS_TRC_SUMMARY } = STUDENT_SUMMARY_PATHS;
const PROGRESS_TAB = 'Progress';
const TEXT_READING_HISTORY_TAB = 'Text Reading History';

export const BENCHMARK_HISTORY_TAB = 'Benchmark History';

export const SS_NAV_TABS_DATA = {
    benchmark_history: { title: BENCHMARK_HISTORY_TAB },
    trc_summary: { title: TEXT_READING_HISTORY_TAB },
    progress: { title: PROGRESS_TAB },
};

// `isProgressSummaryAvailable` flag is temporary, will be removed when Progress Summary is implemented
export const getStudentSummaryNavTabs = (
    location,
    urls,
    isTRCSummaryAvailable,
    isProgressSummaryAvailable,
) => {
    const { BENCHMARK_HISTORY, PROGRESS, TRC_SUMMARY } = urls;
    const params = isEmpty(location) ? null : getUrlParams(location);
    return compact([
        {
            id: SS_BENCHMARK_HISTORY,
            title: BENCHMARK_HISTORY_TAB,
            path: getUrlString(BENCHMARK_HISTORY, params),
        },
        isTRCSummaryAvailable && {
            id: SS_TRC_SUMMARY,
            title: TEXT_READING_HISTORY_TAB,
            path: getUrlString(TRC_SUMMARY, params),
        },
        isProgressSummaryAvailable && {
            id: SS_PROGRESS,
            title: PROGRESS_TAB,
            path: getUrlString(PROGRESS, params),
        },
    ]);
};
